import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import pic1 from './pic1.jpg';
import pic2 from './pic2.jpg';
import css from './AboutPage.module.css';
import image from './Cover.jpg';

const AboutPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  const isContact = typeof window !== 'undefined' ? window.location.hash === '#contact' : false;
  // prettier-ignore
  return (
    <StaticPage
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: 'About Host4Ukraine',
        name: 'About page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>


        {isContact ?
             <>
             <div>
             <h1 className={css.pageTitle}>Contact</h1>
             <p>
             If you want to offer or if you are looking for accommodation, jobs, supplies or other help, please click the button „+Create new listing“ on the homepage.
             </p>

             <p>
             If you want to get in touch with the creator of a listing, you can directly contact him by simply clicking the contact button and instantly start a conversation via our built-in messenger. 
             </p>

             <p>
              If you have further questions, please check our <a href='/faq'>FAQ section.</a> If you can’t find an answer to your question there, feel free to reach out to us by using the following email contact@host4ukraine.com
             </p>
            </div>
            </>
            :
          <>
          <h1 className={css.pageTitle}>About Host4Ukraine</h1>
          {/* <img className={css.coverImage} src={image} alt="h4ukr" /> */}
          <p>
            Host4Ukraine is an online platform with the mission to connect Ukrainian refugees with helpers around the world – in real time. Helpers offer free accommodation, jobs, supplies or services.
          </p>
          <p>
            Since no intermediary is needed and helpers can instantly connect with refugees, the platform matches people unbureaucratically and faster than by traditional means. To this effect, Host4Ukraine has proven to be a highly effective platform.  
          </p>

          <p>
            We encourage everyone to take heart and take part. If you are unable to offer accommodation or other services and supplies, you can spread the word and share Host4Ukraine with your friends and family as well as in your social media or help us with a donation. For more information <a href='/help-and-donate'>click here</a> .
          </p>

          <h1 className={css.pageTitle}>Who we are</h1>
          
          <p>
            Host4Ukraine was launched February 26th, 2022, two days after Putin invaded Ukraine. With a hardworking team of volunteers, we try to help as many Ukrainian refugees as possible through our platform. 
          </p>
          
          <p>
          The goal is to provide an easy, secure and scalable platform to connect those in need with people and organizations that are willing and able to help. 
          </p>

          <p>
          Shortly after launch, hosts from all over the world signed up and offered their help to people in need. By now, over 10.000 beds from over 40 countries have been made available and thousands of hosts and refugees have been successfully matched already. 
          </p>

          <p>
          Host4Ukraine has received many requests from various organizations to help coordinate relief efforts beyond accommodation. Hence, Host4Ukraine is now extended to include further categories such as donations, jobs, services and supplies. For safety purposes, measures such as identity verifications are implemented. 
          </p>

          <p>
          Host4Ukraine is a civic engagement platform that enables private people as well as companies, NGOs, churches and other help organizations to tackle the needs of the Ukrainian refugee crisis. 
          </p>

          <h1 className={css.pageTitle}>The initiators</h1>

          <img className={css.coverImage} src={pic2} alt="h4ukr" />

          <p>
          Host4Ukraine is an initiative of Churchpool. It is furthermore supported by churches, organizations and volunteers around the globe. <a href='partners'>Click here to learn more</a>
          </p>

          <p>
          Churchpool is a German digital communication and content platform that connects parish members with their parishes and churches. For more information about us, visit our website: <a href='https://www.churchpool.com'>www.churchpool.com</a>   
          </p>

          <img className={css.coverImage} src={pic1} alt="h4ukr" />
          </>

        }
          
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default AboutPage;
